import { useNavigate, useParams } from "#src/Routers/hooks";
import { WorkflowDetailsRoutePath } from "../../../detail";

/**
 * ON WEB APP, this page component is just a simple redirector that
 * takes user to workflow details page with an extra URL param: `task_id`
 *
 * (FYI) On mobile app however, task details has its own page.
 */
const WorkflowTaskDetailsPage = () => {
  const navigate = useNavigate();

  const urlParams = useParams<{ workflowId: string; taskId: string }>();

  navigate(
    WorkflowDetailsRoutePath.toLinkParts({
      pathParams: { workflowId: urlParams.workflowId },
      queryParams: { task_id: urlParams.taskId },
    })
  );

  return null;
};

export default WorkflowTaskDetailsPage;
